import Edu_seasonsModel from '../Apis/Edu_seasons'
import Controller from './Controller'

export default class Edu_seasonsController extends Controller {
  constructor() {
    super(new Edu_seasonsModel())
  }
 
  async register_available(){
    return await this.model.register_available();
  }

}
